<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Appendix"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        员工报班优惠制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠 OA 申请流程及填写规范</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第一步：登录OA系统（oa.xdf.cn，账户密码与个人企业邮箱同步），点击【工作流】-【新建工作】-【天津新东方学校自建流程】-【人力资源部】-【【津】员工报班优惠申请】-【新建并办理】。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠 OA 申请流程及填写规范</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第二步：按照页面提示填写基本信息。根据实际情况选择【申请类型】、填写【报班信息】及【报班状态】。其中【五折申请】适用于个人及子女使用，子女使用时需点击【+添加附件】上传出生证明；【八折申请】可选择使用本人名额或他人名额，使用他人名额时需选择告知名额持有人。确认无误后点击【提交】。</p>
                    <img src="../../assets/12.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按下载附加文件</sup>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠 OA 申请流程及填写规范</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第三步：部门审批人审批后转交至人力优惠专员。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第四步：人力优惠专员进入办理，填写优惠码及优惠后金额，转交至人力总监审批。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第五步：人力总监审批后，转交业务操作承接人，承接人确认办理，意见区填写批件信息。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第六步：承接人填写批件信息后，转交批件组，批件人将批件号填写在批件码处，转交给承接人。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠 OA 申请流程及填写规范</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第七步：承接人系统操作完办理，如是“已报班退优惠”，且需要非原交费路径退款的，需在业务办理备注填写九项信息，原路径退款的，需在业务办理备注填写原路径退费，转交财务王征雁。如已原价交费并选择原路径退回优惠差额，则仅需优惠申请人提交 OA 并等待费用退回即可，不需再到校区办理。</p>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {

        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "5"
                }
            })
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Appendix/appendix4.vue